import { useMutation, useQueryClient } from '@tanstack/react-query';
import { rejectPot } from '../api/potsApi';
import { potKeys } from './potKeys';

interface RejectPotParams {
  potId: string;
  reasons: string[];
}

/**
 * Mutation hook for rejecting a pot with one or more reasons.
 *
 * Errors are handled by the global QueryClient onError (shows snackbar).
 * Callers can override with mutate(data, { onSuccess, onError }).
 */
export function useRejectPot() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ potId, reasons }: RejectPotParams) => {
      return await rejectPot(potId, { reasons });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: potKeys.all });
      queryClient.invalidateQueries({ queryKey: potKeys.details() });
    },
  });
}
